var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 66,
    viewBox: "0 0 102 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.45 0H2.55C1.1475 0 0 1.1 0 2.44444V63.5556C0 64.9 1.1475 66 2.55 66H99.45C100.852 66 102 64.9 102 63.5556V2.44444C102 1.1 100.852 0 99.45 0ZM93.33 4.88889L51 45.4667L8.67 4.88889H93.33ZM5.1 8.31111L30.855 33L5.1 57.6889V8.31111ZM8.7975 61.1111L34.425 36.5444L49.215 50.7222C50.235 51.7 51.765 51.7 52.785 50.7222L67.575 36.5444L93.2025 61.1111H8.7975ZM96.9 57.6889L71.145 33L96.9 8.31111V57.6889Z",
    fill: "url(#paint0_linear_264_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_10",
    x1: 0.00000194212,
    y1: 33,
    x2: 98.3004,
    y2: 121.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BEA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.6b80e8ecaac7d31c6e610e0dc7bd1364.svg";
export { ForwardRef as ReactComponent };